export default __webpack_public_path__ + "by.e84ec90f.svg";